@if (name) {
  <svg [class]="'icon ' + size + ' ' + color">
    <use [attr.xlink:href]="'/assets/img/svgs/icon-sprite.svg?v=' + APP_VERSION + '#' + name" />
  </svg>
}
